import { Link } from "react-router-dom";
import { Languages, ArrowLeft } from "lucide-react";

export default function LegalLayout({ title, updated, children, testid }) {
  return (
    <div className="min-h-screen bg-zinc-50 text-zinc-900" data-testid={testid}>
      <header className="border-b border-zinc-200 bg-white">
        <div className="max-w-4xl mx-auto px-6 lg:px-10 py-5 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2.5" data-testid="legal-home-link">
            <div className="w-9 h-9 rounded-lg bg-zinc-900 flex items-center justify-center">
              <Languages className="w-4.5 h-4.5 text-white" />
            </div>
            <span className="font-heading text-lg tracking-tight">
              Clinico Translate<sup className="text-[10px] ml-0.5 text-zinc-500">™</sup>
            </span>
          </Link>
          <Link
            to="/"
            className="inline-flex items-center gap-1.5 text-sm text-zinc-600 hover:text-zinc-900"
            data-testid="legal-back-link"
          >
            <ArrowLeft className="w-4 h-4" />
            Back to site
          </Link>
        </div>
      </header>

      <main className="max-w-4xl mx-auto px-6 lg:px-10 py-14">
        <div className="mb-10">
          <p className="text-xs uppercase tracking-[0.2em] text-zinc-500 mb-3">Legal</p>
          <h1 className="text-4xl sm:text-5xl font-heading tracking-tight text-zinc-950 mb-3" data-testid="legal-title">
            {title}
          </h1>
          <p className="text-sm text-zinc-500" data-testid="legal-updated">Last updated: {updated}</p>
        </div>

        <article className="legal-prose text-zinc-700 leading-relaxed text-[15px] space-y-4">
          {children}
        </article>

        <div className="mt-16 pt-8 border-t border-zinc-200 flex items-center justify-between flex-wrap gap-3">
          <p className="text-xs text-zinc-500">
            © 2026 Wellness and Lifestyle Strategies LLC. All rights reserved. &quot;Clinico Translate&quot;<sup className="text-[9px]">™</sup> is a trademark of Wellness and Lifestyle Strategies LLC.
          </p>
          <Link to="/" className="text-xs text-zinc-600 hover:text-zinc-900" data-testid="legal-footer-home">
            clinicotranslate.com
          </Link>
        </div>
      </main>
    </div>
  );
}
